import { Navigate } from 'react-router-dom'

export const KitchenMembershipsPage = () => <Navigate to="/mealplan" replace />
